import { Stages } from 'components';
import { Modal } from 'components';
import { appActions } from 'store/app/slice';
import { useDispatch } from 'store/utils';

export const TasksStageModal = () => {
  const dispatch = useDispatch();

  const onCloseHandler = () => {
    dispatch(appActions.setIsModalOpened({ name: 'tasksModal', isOpened: false }));
  };

  return (
    <Modal title="Tasks" onClose={onCloseHandler} type="tasksModal">
      <Stages />
    </Modal>
  );
};
